import React from 'react';
import { useToggle } from 'hooks';
import { Button } from 'ui';
import SheetSvg from './icons/SheetSvg';
import UniversalPickerModal from './UniversalPickerModal';

const SelectContent = ({ requestUpdateAndApplyChanges, setIsLoading }) => {
  const [modalVisible, toggleModalVisible] = useToggle();
  return (
    <div className="EditorElement-body SeismicContent">
      <div className="SeismicContent-Initial">
        <SheetSvg />
        <Button type="button" onClick={toggleModalVisible}>
          {t('questions.types.content.select_content')}
        </Button>
        {modalVisible && (
          <UniversalPickerModal
            requestUpdateAndApplyChanges={requestUpdateAndApplyChanges}
            closeModal={toggleModalVisible}
            setIsLoading={setIsLoading}
          />
        )}
      </div>
    </div>
  );
};

export default SelectContent;
